export const MODULE_PERMISSION_CATALOG = [
  { key: 'notificacoes-operacionais', label: 'Notificações', defaultAllowed: true },
  { key: 'caderno', label: 'Caderno de Campo', defaultAllowed: true },
  { key: 'alertas', label: 'Alertas', defaultAllowed: true },
  { key: 'sensoriamento', label: 'Central de Operações', defaultAllowed: false },
  { key: 'propriedades', label: 'Propriedades e Talhões', defaultAllowed: false },
  { key: 'previsao', label: 'Previsão Climática', defaultAllowed: false },
  { key: 'sensores', label: 'Sensores', defaultAllowed: false },
  { key: 'irrigacao', label: 'Irrigação', defaultAllowed: false },
  { key: 'produtividade', label: 'Desempenho da Safra', defaultAllowed: false },
  { key: 'pecuaria', label: 'Pecuária', defaultAllowed: false },
];

export const UNRESTRICTED_ACCOUNT_SCREENS = new Set(['dashboard', 'perfil', 'planos']);
export const SENSOR_ONLY_PLAN_ID = 'sensor_free';
export const SENSOR_ONLY_ACCOUNT_SCREENS = new Set(['perfil']);

// A grade comercial vende os módulos agronômicos como um pacote completo.
// As diferenças entre Essencial, Profissional e Gestão são aplicadas pelos
// limites e recursos de cada plano, não pela ausência de telas do produto.
export const FULL_PLATFORM_PLAN_IDS = Object.freeze([
  'starter',
  'essential',
  'professional',
  'management',
  'enterprise',
]);

const FULL_PLATFORM_PLAN_SET = new Set(FULL_PLATFORM_PLAN_IDS);

export const deniedModuleName = moduleKey => `deny:${moduleKey}`;

export function isModuleIncludedInPlan(moduleKey, planId = null) {
  const definition = MODULE_PERMISSION_CATALOG.find(item => item.key === moduleKey);
  if (!definition) return false;
  if (planId === SENSOR_ONLY_PLAN_ID) return moduleKey === 'sensores';
  if (FULL_PLATFORM_PLAN_SET.has(planId)) return true;
  return definition.defaultAllowed;
}

export function getPlanIncludedModules(planId = null) {
  return MODULE_PERMISSION_CATALOG
    .filter(module => isModuleIncludedInPlan(module.key, planId))
    .map(module => module.key);
}

export function getPlanHomeTarget(planId, isAdmin = false) {
  return !isAdmin && planId === SENSOR_ONLY_PLAN_ID ? 'sensores' : 'dashboard';
}

export function isModuleAllowed(moduleKey, permissionRows = [], isAdmin = false, planId = null) {
  if (isAdmin) return true;
  if (moduleKey === 'colaboracao') return true; // Aceitar convite não exige assinatura.
  const assigned = new Set(permissionRows || []);
  if (assigned.has(deniedModuleName(moduleKey))) return false;
  if (planId === SENSOR_ONLY_PLAN_ID) {
    return moduleKey === 'sensores' || SENSOR_ONLY_ACCOUNT_SCREENS.has(moduleKey);
  }
  if (assigned.has(`shared:${moduleKey}`)) return Boolean(MODULE_PERMISSION_CATALOG.find(item => item.key === moduleKey));
  if (UNRESTRICTED_ACCOUNT_SCREENS.has(moduleKey)) return true;

  const definition = MODULE_PERMISSION_CATALOG.find(item => item.key === moduleKey);
  if (!definition) return false;

  return isModuleIncludedInPlan(moduleKey, planId) || assigned.has(moduleKey);
}

export function permissionMutationFor(moduleKey, allowed, planId = null) {
  const definition = MODULE_PERMISSION_CATALOG.find(item => item.key === moduleKey);
  if (!definition) throw new Error(`Módulo desconhecido: ${moduleKey}`);

  const defaultAllowed = isModuleIncludedInPlan(moduleKey, planId);

  return allowed
    ? { insert: defaultAllowed ? null : moduleKey, remove: deniedModuleName(moduleKey) }
    : { insert: defaultAllowed ? deniedModuleName(moduleKey) : null, remove: moduleKey };
}

export function getAuthorizedModuleTarget(moduleKey, permissionRows = [], isAdmin = false, planId = null, fallback = null) {
  const resolvedFallback = fallback || getPlanHomeTarget(planId, isAdmin);
  return isModuleAllowed(moduleKey, permissionRows, isAdmin, planId) ? moduleKey : resolvedFallback;
}
